import { createAsyncThunk } from "@reduxjs/toolkit";
import ticketServices from "../../services/ticketServices";
import { showLoading,closeLoading,showError } from "../slices/commonSlice";

export const getMyTickets=createAsyncThunk(
    "my-tickets",
    async(payload,thunkApi)=>{
    try{
        thunkApi.dispatch(showLoading());
        let response=await ticketServices.getMyTickets(payload);
        thunkApi.dispatch(closeLoading());
        return response.data;
    }catch(error){
        thunkApi.dispatch(closeLoading());
        thunkApi.dispatch(showError(error.response.data.message));
        return thunkApi.rejectWithValue(error.response.data.message);
      }
    }
);

export const getTicketsByConfirmationID=createAsyncThunk(
    "get-tickets-by-confirmationid",
    async(payload,thunkApi)=>{
    try{
        thunkApi.dispatch(showLoading());
        let response=await ticketServices.getTicketsByConfirmationID(payload);
        thunkApi.dispatch(closeLoading());
        return response.data;
    }catch(error){
        thunkApi.dispatch(closeLoading());
        thunkApi.dispatch(showError(error.response.data.message));
        return thunkApi.rejectWithValue(error.response.data.message);
      }
    }
);

// export const getExpiredTickets=createAsyncThunk(
//     "expired-tickets",
//     async(payload,thunkApi)=>{
//     try{
//         thunkApi.dispatch(showLoading());
//         let response=await ticketServices.getMyTickets({type:'expired'});
//         thunkApi.dispatch(closeLoading());
//         return response.data;
//     }catch(error){
//         thunkApi.dispatch(closeLoading());
//         thunkApi.dispatch(showError(error.response.data.message));
//         return thunkApi.rejectWithValue(error.response.data.message);
//       }
//     }
// );